// Abu Dhabi - personal trainer for seniors.
const content = {
    slug: 'personal-trainer-for-seniors',
    title: 'Personal Trainer for Seniors in Abu Dhabi | At Home',
    description: (c) =>
        `Home personal training for seniors in Abu Dhabi: strength, balance and mobility with a patient, qualified trainer. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Abu Dhabi · Seniors',
    h1: 'Personal Trainer for Seniors in Abu Dhabi',
    lead: 'In many Abu Dhabi households, grandparents live with the family. Regular, gentle strength training at home helps them stay steady on their feet, keep up with grandchildren and recover faster from illness.',
    image: 'blog/health+and+fitness/elderly-fitness.webp',
    imageAlt: 'Senior doing a balance exercise with support',
    facts: ['Gentle and supervised', 'At home', 'Doctor-aware plans'],
    ctaLabel: 'Request a trainer for a family member',
    matchSummary: 'a personal trainer for a senior family member in Abu Dhabi',
    packagesTitle: 'Packages',
    packagesIntro: 'Two short sessions a week suit most older adults. Family members can train alongside on the partner rate.',
    sections: [
        {
            title: 'A typical session',
            steps: [
                { title: 'Check-in', body: 'How they slept, any pain, blood pressure if relevant.' },
                { title: 'Warm-up', body: 'Gentle joint movements and walking in place.' },
                { title: 'Strength', body: 'Chair-based and supported exercises for legs, back and arms.' },
                { title: 'Balance', body: 'Short, supported drills to reduce fall risk.' },
                { title: 'Cool-down', body: 'Stretching and breathing; a few exercises to do between sessions.' },
            ],
        },
        {
            title: 'Health conditions',
            tone: 'muted',
            paragraphs: [
                'Diabetes, high blood pressure, arthritis and joint replacements are common, and none of them rules out exercise. Share any conditions and medications when you book; the trainer works within the limits set by the doctor and adjusts on bad days.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is my 70-year-old parent too old for a personal trainer?',
            answer: 'No. Strength training benefits people well into their 80s and 90s, when it is adapted to their health and pace.',
        },
        {
            question: 'Can a family member join the session?',
            answer: 'Yes, on the partner rate - many families find it motivates the older person to keep going.',
        },
        {
            question: 'Do you need a doctor\'s note?',
            answer: 'For heart conditions, recent surgery or uncontrolled blood pressure, yes. Otherwise the trainer asks health questions at the first session.',
        },
    ],
    schema: { name: 'Personal Training for Seniors in Abu Dhabi' },
}

export default content
